module.exports = __webpack_public_path__ + "img/fire_rated_fs.5e073e4f.png";